import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IPhoneSkinProps = IContainerProps;

const styles = stylex.create({
  frame: {
    fill: colorSchemeTokens.outlineVariant,
  },
  button: {
    fill: colorSchemeTokens.outline,
  },
});

export const PhoneSkin: React.FC<IPhoneSkinProps> = ({ sx }): JSX.Element => (
  <svg
    width="408"
    height="831"
    viewBox="0 0 408 831"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...stylex.props(sx)}
  >
    <path
      d="M0 130.791C0 129.802 0.801755 129 1.79077 129H10.2092C11.1983 129 12 129.802 12 130.791V160.209C12 161.198 11.1983 162 10.2092 162H1.79077C0.801755 162 0 161.198 0 160.209V130.791Z"
      {...stylex.props(styles.button)}
    />
    <path
      d="M0 190.791C0 189.802 0.801755 189 1.79077 189H10.2092C11.1983 189 12 189.802 12 190.791V250.209C12 251.198 11.1983 252 10.2092 252H1.79077C0.801755 252 0 251.198 0 250.209V190.791Z"
      {...stylex.props(styles.button)}
    />
    <path
      d="M0 271.791C0 270.802 0.801755 270 1.79077 270H10.2092C11.1983 270 12 270.802 12 271.791V331.209C12 332.198 11.1983 333 10.2092 333H1.79077C0.801755 333 0 332.198 0 331.209V271.791Z"
      {...stylex.props(styles.button)}
    />
    <path
      d="M396 214.791C396 213.802 396.802 213 397.791 213H406.209C407.198 213 408 213.802 408 214.791V307.209C408 308.198 407.198 309 406.209 309H397.791C396.802 309 396 308.198 396 307.209V214.791Z"
      {...stylex.props(styles.button)}
    />
    <mask
      id="mask0_602_31"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="-28"
      y="-30"
      width="477"
      height="902"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M449 -30H-28V872H449V-30ZM335 18H85V72H335V18Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_602_31)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00029 35.2339C6.00029 17.4316 20.4319 3 38.2342 3H369.767C387.569 3 402.001 17.4316 402.001 35.2339V795.767C402.001 813.569 387.569 828.001 369.767 828.001H38.2342C20.4319 828.001 6.00029 813.569 6.00029 795.767V35.2339ZM21.0004 43.0707C21.0004 29.2245 32.225 17.9999 46.0712 17.9999H105.001V35.4646C105.001 42.3877 110.613 48 117.536 48H290.465C297.389 48 303.001 42.3877 303.001 35.4646V17.9999H361.93C375.776 17.9999 387.001 29.2245 387.001 43.0707V787.93C387.001 801.776 375.776 813 361.93 813H46.0712C32.225 813 21.0004 801.776 21.0004 787.93V43.0707Z"
        {...stylex.props(styles.frame)}
      />
      <path
        d="M261 27C261 30.3137 258.313 33 255 33C251.686 33 249 30.3137 249 27C249 23.6863 251.686 21 255 21C258.313 21 261 23.6863 261 27Z"
        fill="black"
      />
    </g>
  </svg>
);
